import React from 'react'
import clamp from 'lodash-es/clamp'

import T from 'components/FormattedMessage'
import Currency from 'components/Currency'

import Typography from '@material-ui/core/Typography'
import { WithStyles, createStyles, withStyles, Theme } from '@material-ui/core/styles'

import { IMoney } from 'protos'

import AchievementBadge from '../AchievementBadge'

interface Props {
  level: number
  title?: React.ReactChild
  earnedBonus?: IMoney | null
}

const styles = (theme: Theme) => createStyles({
  spacing: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const LatestAchievement: React.SFC<InjectedProps> = ({ classes, level, earnedBonus, title }) => {
  level = clamp(level | 0, 0, 6) // tslint:disable-line:no-bitwise

  return (
    <div>
      <AchievementBadge className={classes.spacing} size="large" level={level} checked />
      <Typography variant="body1" align="center">
        {title || '-'}
      </Typography>
      <Typography className={classes.spacing} variant="h5" align="center">
        +<Currency {...earnedBonus} />
      </Typography>
      {level > 0 && (
        <Typography variant="h3" align="center">
          <T id="achievements_bonus_help" values={{ level }} />
        </Typography>
      )}
    </div>
  )
}

export default withStyles(styles)(LatestAchievement)
